import { View, Text } from 'react-native'
import React from 'react'
import { NativeStackNavigationProp, NativeStackScreenProps } from '@react-navigation/native-stack'
import { PrivateStackParamList } from '../../navigationApp/types'
import { ThemedView } from '../../theme'
import BackButton from '../../sharedComponents/BackButton/BackButton'
import Typography from '../../sharedComponents/typography/Typography'
import { ColorTokens, TypographyTypeDLS } from '@voltmoney/schema'
import WebView from 'react-native-webview'
import ScreenWrapper from '@app/hoc/ScreenWrapper'


type ScreenProps = NativeStackScreenProps<PrivateStackParamList , 'WEBVIEW_SCREEN'>

const WebviewScreen = ({ navigation , route} : ScreenProps) => {
  return (
    <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute : true , label : route?.params?.label }}>
    <ThemedView bg='bg-surface-primary' flex={1}>
      <ThemedView borderBottomWidth={1} borderBottomColor='border-secondary' p='lg' flexDirection='row' alignItems='center'>
        <ThemedView mr='md'>
          <BackButton navigation={navigation} />
        </ThemedView>
        <Typography label={route?.params?.label} color={ColorTokens.Grey_Night} />
      </ThemedView>
      <WebView style={{ flex: 1 }} source={{ uri: route?.params?.url }} />
    </ThemedView>
    </ScreenWrapper>
  )
}

export default WebviewScreen